import React, { useEffect } from 'react';
import CreateGroupForm from './CreateGroupForm';
import './CreateGroupForm.css';

const CreateGroupModal = ({ onClose }) => {

    // ✅ Prevent background scrolling when modal is open
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    // ✅ Handle clicking on the backdrop to close
    const handleBackdropClick = (e) => {
        if (e.target.className === 'modal-backdrop') {
            onClose();
        }
    };

    return (
        <div className="modal-backdrop" onClick={handleBackdropClick}>
            <div className="modal-content">
                <button
                    className="modal-close-btn"
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    &times;
                </button>

                <div className="modal-header">
                    <h3>Create New Group</h3>
                </div>

                {/* The Form handles the actual API call and calling onClose on success */}
                <CreateGroupForm onClose={onClose} />
            </div>
        </div>
    );
};

export default CreateGroupModal;